function TextBanner(props) {
  const endpoint = 'https://tlfapparel.myshopify.com/api/2023-01/graphql.json';
  const headers = new Headers({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Shopify-Storefront-Access-Token': '74b04c14043788de101005846d4afafb'
  });
  const query = () => `{
        metaobject(handle: {handle: "main-text-banner", type: "announcement_bar"}) {
            field(key: "messages") {
                references(first: 10) {
                    nodes {
                        ... on Metaobject {
                            fields {
                                key
                                value
                                type
                            }
                        }
                    }
                }
            }
        }
    }`;
  const [banners, setBanners] = React.useState([]);
  const [bannerLocation, setBannerLocation] = React.useState(0);
  const [currentTextBanner, setCurrentTextBanner] = React.useState(0);
  const [hover, setHover] = React.useState(false);
  function timeNow(start, end) {
    let now = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    });
    let now_time = new Date(now).getTime();
    let afterStart = false;
    let beforeEnd = false;
    if (start) {
      let startTime = new Date(start).toLocaleString("en-US", {
        timeZone: "America/New_York"
      });
      let start_time = new Date(startTime).getTime();
      if (now_time > start_time) {
        afterStart = true;
      }
    } else {
      afterStart = true;
    }
    if (end) {
      let endTime = new Date(end).toLocaleString("en-US", {
        timeZone: "America/New_York"
      });
      let end_time = new Date(endTime).getTime();
      if (now_time < end_time) {
        beforeEnd = true;
      }
    } else {
      beforeEnd = true;
    }
    return afterStart && beforeEnd ? true : false;
  }
  React.useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: query()
      })
    });
    const data = await response.json();
    let unfilteredBanners = [];
    console.log(data);
    if (data?.data) {
      let banner = data?.data?.metaobject?.field?.references?.nodes;
      for (let i = 0; i < banner.length; i++) {
        let fields = banner[i].fields;
        let message_content = '';
        let start_time = '';
        let end_time = '';
        let link = '';
        let custom_css = '';
        let background_color = '';
        let button_text = '';
        let text_color = '';
        for (let j = 0; j < fields.length; j++) {
          switch (fields[j].key) {
            case 'message_content':
              message_content = fields[j].value;
              break;
            case 'start_time':
              start_time = fields[j].value;
              break;
            case 'end_time':
              end_time = fields[j].value;
              break;
            case 'background_color':
              background_color = fields[j].value;
              break;
            case 'button_text':
              button_text = fields[j].value;
              break;
            case 'text_color':
              text_color = fields[j].value;
              break;
            case 'link_to':
            case 'link_to_product':
            case 'link_to_collection':
            case 'link_to_outside_url':
              link = fields[j].value;
              break;
          }
        }
        unfilteredBanners.push({
          message_content: message_content,
          start_time: start_time,
          end_time: end_time,
          link: link,
          custom_css: custom_css,
          background_color: background_color,
          button_text: button_text,
          text_color: text_color
        });
      }
      let filteredBanners = unfilteredBanners.filter(item => timeNow(item.start_time || false, item.end_time || false));
      // filteredBanners.push({
      //     message_content: 'TAKE 10% OFF!',
      //     start_time: '',
      //     end_time: '',
      //     link: '',
      //     custom_css: '',
      //     open_ten_percent: true,
      //     button_text: 'Click Here',
      // });

      setBanners(filteredBanners);
    }
  }
  const toLocation = direction => {
    let toTextBanner = currentTextBanner;
    if (direction === -1) {
      currentTextBanner > 0 ? toTextBanner-- : toTextBanner = banners.length - 1;
    } else {
      banners.length > currentTextBanner + 1 ? toTextBanner++ : toTextBanner = 0;
    }
    let percentChange = 100 / banners.length;
    setCurrentTextBanner(toTextBanner);
    setBannerLocation(toTextBanner * percentChange);
  };
  React.useEffect(() => {
    const autoSlider = setInterval(() => {
      if (!hover) {
        toLocation(1);
      }
    }, 8000);
    return () => {
      clearInterval(autoSlider);
    };
  }, [toLocation, hover]);
  React.useEffect(() => {
    console.log(banners);
  }, [banners]);
  function open_ten_percent(open_ten_percent) {
    if (open_ten_percent) {
      let ju_tab_text = document.getElementById('ju_tab_text');
      ju_tab_text.click();
    }
  }
  function CustomButton(props) {
    const [buttonText, setButtonText] = React.useState('');
    React.useEffect(() => {
      setButtonText(props.text);
    }, [props]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, buttonText && buttonText.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: '5px'
      }
    }, "-"), /*#__PURE__*/React.createElement("span", {
      className: "customButton",
      style: {
        color: props.color,
        border: `1px solid ${props.color}`
      }
    }, buttonText)));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, banners && banners.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "announcement FadeIn textBannerContainer",
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, /*#__PURE__*/React.createElement("div", {
    className: "textBannerInnerContainer"
  }, banners.map((textBanner, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, textBanner.link.length > 0 ? /*#__PURE__*/React.createElement("a", {
    className: `textBannerLink`,
    style: {
      marginLeft: `${index === 0 ? `-${bannerLocation}%` : ``}`,
      background: textBanner.background_color
    },
    href: `${textBanner.link}`
  }, /*#__PURE__*/React.createElement("p", {
    className: "textBannerText",
    style: {
      color: textBanner.text_color
    }
  }, textBanner.message_content, /*#__PURE__*/React.createElement(CustomButton, {
    text: textBanner.button_text,
    color: textBanner.text_color
  }))) : /*#__PURE__*/React.createElement("div", {
    className: `textBannerLink`,
    style: {
      marginLeft: `${index === 0 ? `-${bannerLocation}%` : ``}`,
      background: textBanner.background_color
    },
    onClick: () => open_ten_percent(textBanner?.open_ten_percent)
  }, /*#__PURE__*/React.createElement("p", {
    className: "textBannerText",
    style: {
      color: textBanner.text_color
    }
  }, textBanner.message_content, /*#__PURE__*/React.createElement(CustomButton, {
    text: textBanner.button_text,
    color: textBanner.text_color
  }))))))));
}
const textBannerContainer = document.querySelector('#textBanner');
const rootForTextBanner = ReactDOM.createRoot(textBannerContainer);
rootForTextBanner.render( /*#__PURE__*/React.createElement(TextBanner, null));
